export const ClientId = {
  xxs: 'sd_mobile',
  xs: 'sd_mobile',
  sm: 'sd_mobile',
  md: 'sd_tablet',
  lg: 'sd_desktop',
  xl: 'sd_desktop',
  xxl: 'sd_desktop',
} as const;

export type ClientId = (typeof ClientId)[keyof typeof ClientId];
